<template>
  <layoutDefault>
    <!-- title -->
    <ContentTitle ref="top" title="건강백세 목록"></ContentTitle>

    <form @submit.prevent="loadData(false)">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select v-model="formData.contentType">
                <option value>콘텐츠 전체</option>
                <option value="HEALTHTOKTOK">건강톡톡</option>
                <option value="GOODTHINKING">좋은생각</option>
                <option value="MINDGYM">마음체조</option>
              </select>
              <select v-model="formData.useYn">
                <option value>사용여부</option>
                <option value="Y">사용중</option>
                <option value="N">미사용</option>
              </select>

              <select v-model="formData.searchType">
                <option value>제목+키워드</option>
                <option value="title">제목</option>
                <option value="keyword">키워드</option>
              </select>

              <input type="text" class="inp_text blank" style="width: 300px" v-model.trim="formData.searchValue" ref="searchInput" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <PagingTable :sourceList="tableItems" ref="table">
      <template #header>
        <caption>
          <span class="blind">건강톡톡 목록</span>
        </caption>
        <colgroup>
          <col width="5%" />
          <col width="8%" />
          <col />
          <col width="6%" />
          <col width="8%" />
          <col width="8%" />
          <col width="6%" />
          <col width="7%" />
          <col width="7%" />
          <col width="12%" />
        </colgroup>

        <thead class="table_list_head">
          <tr>
            <th class="sorting" data-sort="id">번호</th>
            <th class="sorting" data-sort="contentType">콘텐츠 구분</th>
            <th class="sorting" data-sort="boardTitle">{{ searchTypeString }}</th>
            <th class="sorting" data-sort="soundInfo">음원정보</th>
            <th class="sorting" data-sort="createDate">등록일</th>
            <th class="sorting" data-sort="updateDate">수정일</th>
            <th class="sorting" data-sort="playCount">play수</th>
            <th class="sorting" data-sort="fileType">추천정보여부</th>
            <th class="sorting" data-sort="useYn">사용여부</th>
            <th>수정/삭제</th>
          </tr>
        </thead>
      </template>
      <template #row="{rowData}">
        <Item :key="rowData.id" :itemData="rowData" @clickRegister="onClickRegister(rowData)" @stateChange="loadData(true)" />
      </template>
    </PagingTable>

    <!-- 버튼 영역 -->
    <div class="section_button">
      <button type="button" class="btn_register" @click="onClickRegister()">등록</button>
    </div>
  </layoutDefault>
</template>

<script>
import Item from './Item';
import Register from './popups/Register';

export default {
  name: 'Health',
  components: {Item},
  data() {
    return {
      tableItems: null,
      formData: {
        useYn: '',
        searchType: '',
        searchValue: '',
        contentType: '',
      },
      searchTypeString: '',
    };
  },
  methods: {
    setSearchTypeString() {
      switch (this.formData.searchType) {
        case 'title':
          this.searchTypeString = '제목';
          return;
        case 'keyword':
          this.searchTypeString = '키워드';
          return;
        default:
          this.searchTypeString = '제목 + 키워드';
          return;
      }
    },
    requestOptions() {
      return {params: this.formData};
    },
    onClickRegister(itemData) {
      this.openPopup(Register, {
        itemData,
        onSubmit: () => this.loadData(!!itemData),
      });
    },
    loadData(keepTableState) {
      if (this.$utils.hasSpecialChar(this.formData.searchValue)) {
        alert('특수문자를 제외하고 검색해 주세요.');
        this.$refs.searchInput.focus();
        return;
      }
      const options = this.requestOptions();
      this.$axios.get('/admin/happy/health/v2/lists', options).then(({data}) => {
        this.tableItems = data.healthBoardDataList;
        if (!keepTableState && this.$refs.table) this.$refs.table.resetState();
        this.setSearchTypeString();
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
